'use client';
import { captureException, captureMessage, withScope } from '@sentry/nextjs';
import React, { PropsWithChildren } from 'react';
import { PACKAGE_NAME, PACKAGE_NAMESPACE } from 'src/constants';

import { GlobalErrorPage } from '../Error';

type ErrorBoundaryProps = PropsWithChildren;

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    withScope((scope) => {
      scope.setTag('namespace', PACKAGE_NAMESPACE);
      scope.setTag('microservice_name', PACKAGE_NAME);
      scope.setTag('origin', 'error_boundary');
      scope.setTag('dev_mode', 'disabled');

      captureMessage(JSON.stringify(errorInfo), {
        level: 'error',
      });
      captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return <GlobalErrorPage />;
    }

    return this.props.children;
  }
}
